'use client';
import { Fragment } from 'react';

import { useAtomValue } from 'jotai';

import { favouritesAtom } from '@core/Atoms/Favourites/Favourites.atom';

type TileEntry = { vehicleId: string; node: React.ReactNode };

export const FavouritesList = ({
  tiles,
  emptyState,
  className,
}: {
  tiles: TileEntry[];
  emptyState: React.ReactNode;
  className: string;
}) => {
  const favs = useAtomValue(favouritesAtom);
  const visibleTiles = tiles.filter(({ vehicleId }) => favs?.includes(vehicleId));

  if (visibleTiles.length === 0) {
    return <>{emptyState}</>;
  }

  return (
    <div className={className} data-test-id="favourite-vehicles-list">
      {visibleTiles.map(({ vehicleId, node }) => (
        <Fragment key={vehicleId}>{node}</Fragment>
      ))}
    </div>
  );
};
